/**
 * `buildEditorInitOptions` — PR-N7 feature flag 헬퍼.
 *
 * `apps/owma/src/vars.ts` 의 `editorType` 변수와 같은 시맨틱:
 *   - `'tinymce'` → `host.mode: 'iframe'` (어댑터가 container 안에 iframe 을 동적 생성, `htmlUrl` 사용)
 *   - `'ngw'`     → `host.mode: 'inline'` (NgwEditor `<Editor />` 가 container 에 직접 마운트)
 *
 * EmailForm / SignatureEdit 양쪽 `setEditorContainer` 호출부에서 동일 패턴으로 사용한다. 두 호출부의
 * 분기 로직 중복을 본 헬퍼로 단일화한다.
 *
 * PR-N8 에서 TinyMCE 어댑터 제거 시 본 헬퍼도 단순화 — `editorType` 인자 자체 제거 + host.mode
 * 'inline' 고정 (또는 호출부 인라인화 후 본 파일 삭제).
 */

import type { EditorDefaultStyle, EditorInitOptions } from './types'

/** PR-N7 feature flag 의 값 도메인. `apps/owma/src/vars.ts` 의 `editorType` 과 동일. */
export type EditorType = 'tinymce' | 'ngw'

/**
 * C7 보강: `defaultStyle` 은 **NgwEditor 한정** 으로만 EditorInitOptions 에 포함된다. TinyMCE
 * 어댑터는 EditorInitOptions.defaultStyle 표면을 무시 (자체 setDefaultStyle 메커니즘 사용) 하므로
 * tinymce 분기에서는 의도적으로 미전달 — "NgwEditor 한정 첫 마운트 폰트 적용" 의 의도 표명.
 */
export function buildEditorInitOptions(
  editorType: EditorType,
  container: HTMLElement,
  htmlUrl?: string,
  nineMailId?: string,
  defaultStyle?: EditorDefaultStyle,
): EditorInitOptions {
  if (editorType === 'ngw') {
    return { nineMailId, defaultStyle, host: { mode: 'inline', container } }
  }
  return { nineMailId, host: { mode: 'iframe', container, htmlUrl } }
}
